var render = function render(_c,_vm){return _c('div',{staticClass:"one-form-container-title",class:_vm.data.staticClass,style:(_vm.data.staticStyle)},[_c('b-form-group',[_c('div',{staticClass:"one-form-container-title__text"},[_vm._v("\n      "+_vm._s(_vm.props.title)+"\n    ")])]),_vm._v(" "),_c('div',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }